<template>
  <v-container fill-height fluid grid-list-xl>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-text>{{DialogErrorMsg}}</v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 
 
    <v-navigation-drawer flat app :fixed="true" :right="true">
      <v-toolbar flat>
        <v-list>
          <v-list-tile>
            <v-list-tile-title class="title">Application</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-toolbar>

      <v-divider></v-divider>

      <v-list dense class="pt-0">
        <v-list-tile v-for="item in items" :key="item.title">
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    -->
    <v-layout wrap>
      <v-flex>
        <material-card v-if="RaceDate">
          <h1>{{RaceDate}} {{RaceLocation}}</h1>
        </material-card>

        <material-card
          v-if="formattedTipsArr && formattedTipsArr.length > 0"
          :title="'Oncc(Sorted): ' + OnccTipsDate"
          :IsHideable="true"
        >
          <v-data-table :headers="formattedOnccHeaders" :items="formattedTipsArr" hide-actions>
            <template slot="items" slot-scope="props" v-if="props.item!=null">
              <td>
                <span style="white-space:nowrap;">{{ props.item.raceNumCHT }}</span>
              </td>
              <td>
                <!--TODO hardcode min-width is bad...-->
                <li
                  style="float:left;text-decoration:none;list-style-type: none; white-space:nowrap;"
                  v-for="tmp in props.item.Tips"
                  v-bind:key="tmp.writer"
                >
                  <table>
                    <tr>
                      <span style="font-weight:bold">{{ tmp.writer}}</span>
                      <br>
                      <span style="font-style: italic;font-size: 0.5rem;">({{ tmp.type }})</span>
                    </tr>
                    <li v-for="c in tmp.choices" v-bind:key="c">{{c}}</li>
                  </table>
                </li>
              </td>
              <td>
                <ul style="white-space:nowrap;">
                  <!--TODO align it-->
                  <li v-for="rec in props.item.horseSelectedCount" v-bind:key="rec.name">
                    {{rec.name}} : {{rec.count}} :
                    <span
                      style="text-decoration: underline;color: green;"
                    >{{rec.riderName}}</span>
                  </li>
                </ul>
              </td>
              <td>
                <span
                  v-if="props.item.horseSuggestion!=null"
                  style="font-weight:bold;color:red;white-space:nowrap;"
                >{{props.item.horseSuggestion.name}}</span>
              </td>
            </template>
          </v-data-table>
        </material-card>

        <material-card
          v-if=" jockeyChallengeStat && jockeyChallengeStat.length > 0"
          title="騎師王"
          :IsHideable="true"
        >
          <ol>
            <li v-for="record in jockeyChallengeStat" v-bind:key="record.riderName">
              <span
                style="text-decoration: underline;
                           color: green;"
              >{{record.riderName}}</span> :
              <span>{{record.count}}</span>
            </li>
          </ol>
        </material-card>

        <material-card
          v-if="formattedRaceInfo && formattedRaceInfo.length > 0"
          class="card-tabs racingSchedule"
          color="#4A8CC1"
        >
          <v-flex slot="header">
            <v-tabs v-model="tabs" color="transparent" slider-color="white">
              <span class="subheading font-weight-light mr-3" style="align-self: center">場次 :</span>
              <v-tab class="mr-3" v-for="n in totalRaceCount" :key="n">
                <v-icon class="mr-2">mdi-calendar-blank</v-icon>
                第{{n}}場
              </v-tab>
            </v-tabs>
          </v-flex>
          <v-tabs-items v-if="formattedRaceInfo[tabs]" v-model="tabs">
            <!--<h3>比賽: {{formattedRaceInfo[tabs].比賽}}</h3>
            <h3>時間: {{formattedRaceInfo[tabs].時間}}</h3>
            -->
            <h3>{{formattedRaceInfo[tabs].全部資訊}}</h3>
            <v-data-table
              :headers="formattedRaceInfoHeaders"
              :items="formattedRaceInfo[tabs].參賽馬匹"
              v-bind:pagination.sync="pagination"
              item-key="馬名"
              hide-actions
              :expand="true"
            >
              <template slot="items" slot-scope="item">
                <tr @click="item.expanded = !item.expanded">
                  <td>{{item.item.檔位}}</td>
                  <td>{{item.item.馬匹編號}}</td>
                  <td>{{item.item.馬名}}</td>
                  <td>{{item.item.排位體重}} ({{item.item["排位體重+/-"]}})</td>
                  <td>{{item.item.負磅}}</td>
                  <td>{{item.item["總體重"]}}</td>
                  <td>{{item.item["評分"]}} ({{item.item["評分+/-"]}})</td>
                  <td>{{item.item.騎師}}</td>
                  <td>{{item.item.練馬師}}</td>
                  <td>{{item.item["6次近績"]}}</td>
                  <td>{{item.item["獨贏"]}}</td>
                  <td>{{item.item["位置"]}}</td>
                  <td>{{item.item["獨贏/位置"]}}</td>
                  <td>{{item.item["騎練(冠亞季負)"]}}</td>
                  <td>{{item.item["騎練(冠%)"] == null?'0.00':item.item["騎練(冠%)"]}}%</td>
                  <td>{{item.item["騎練(冠亞季%)"] == null?'0.00':item.item["騎練(冠亞季%)"]}}%</td>
                  <td>???</td>
                </tr>
              </template>
              <template slot="expand" slot-scope="props">
                <v-card flat>
                  <v-progress-circular :size="70" :width="7" color="purple" indeterminate></v-progress-circular>

                  <v-card-text>{{props.item.馬名}}</v-card-text>
                </v-card>
              </template>
            </v-data-table>
          </v-tabs-items>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      tabs: 0,
      onccHeaders: [
        {
          sortable: false,
          text: "名家",
          value: "名家"
        },
        {
          sortable: false,
          text: "類型",
          value: "類型"
        },
        {
          sortable: false,
          text: "貼士",
          value: "貼士"
        }
      ],
      formattedOnccHeaders: [
        {
          sortable: false,
          text: "場次",
          value: "場次"
        },
        {
          sortable: false,
          text: "貼士",
          value: "貼士"
        },
        {
          sortable: false,
          text: "Sum",
          value: "Sum"
        },
        {
          sortable: false,
          text: "Suggestion (最多人推薦且唯一)",
          value: "Suggestion"
        }
      ],
      formattedRaceInfoHeaders: [
        {
          sortable: true,
          text: "檔位",
          value: "檔位"
        },
        {
          sortable: true,
          text: "馬匹編號",
          value: "馬匹編號"
        },
        {
          sortable: true,
          text: "馬名",
          value: "馬名"
        },
        {
          sortable: true,
          text: "排位體重",
          value: "排位體重"
        },
        {
          sortable: true,
          text: "負磅",
          value: "負磅"
        },
        {
          sortable: true,
          text: "總體重",
          value: "總體重"
        },
        {
          sortable: true,
          text: "評分",
          value: "評分"
        },
        {
          sortable: true,
          text: "騎師",
          value: "騎師"
        },
        {
          sortable: true,
          text: "練馬師",
          value: "練馬師"
        },
        {
          sortable: true,
          text: "6次近績(馬匹)",
          value: "6次近績(馬匹)"
        },
        {
          sortable: true,
          text: "獨贏",
          value: "獨贏"
        },
        {
          sortable: true,
          text: "位置",
          value: "位置"
        },
        {
          sortable: true,
          text: "獨贏/位置",
          value: "獨贏/位置"
        },
        {
          sortable: true,
          text: "騎練(冠亞季負)",
          value: "騎練(冠亞季負)"
        },
        {
          sortable: true,
          text: "騎練(冠%)",
          value: "騎練(冠%)"
        },
        {
          sortable: true,
          text: "騎練(冠亞季%)",
          value: "騎練(冠亞季%)"
        },
        {
          sortable: true,
          text: "值博率",
          value: "值博率"
        }
      ],
      onccLists: [],
      formattedTipsArr: [],
      raceInfo: [],
      corpArr: [],
      formattedRaceInfo: [],
      //騎師王統計資料
      jockeyChallengeStat: [],
      totalRaceCount: 0,
      pagination: { sortBy: "馬匹編號", descending: false, rowsPerPage: -1 },
      RaceLocation: "",
      RaceDate: "",
      OnccTipsDate: "",
      items: [
        { title: "Home", icon: "dashboard" },
        { title: "About", icon: "question_answer" }
      ],
      dialog: false,
      DialogErrorMsg: ""
    };
  },
  async created() {
    var response = null;
    var raceInfo = [];
    var jockeyChallengeStat = [];
    var totalRaceInfo = null;
    var totalRaceCount = null;
    var formattedTipsArr = [];
    var corpArr = [];
    var formattedRaceInfo = [];

    function HandleTips(tips) {
      var raceNum = getNumber(tips.racenum);
      if (formattedTipsArr[raceNum] == null) {
        formattedTipsArr[raceNum] = {};
      }
      //Initialiate array
      if (formattedTipsArr[raceNum].Tips == null) {
        formattedTipsArr[raceNum].Tips = [];
      }
      formattedTipsArr[raceNum].raceNumInt = raceNum;
      formattedTipsArr[raceNum].Tips.push(tips);
      tips.choices.forEach(function(choice) {
        if (formattedTipsArr[raceNum].horseSelectedCount == null) {
          formattedTipsArr[raceNum].horseSelectedCount = [];
        }
        addCountForHorse(
          formattedTipsArr[raceNum].horseSelectedCount,
          choice,
          raceNum
        );
      });
    }

    function addCountForHorse(array, horseName) {
      if (array == null) {
        array = [];
      }
      var targetRecord = array.find(x => x.name == horseName);
      if (targetRecord == null) {
        targetRecord = { name: horseName, count: 1 };
        array.push(targetRecord);
      } else {
        targetRecord.count += 1;
      }
    }

    function getNumber(raceName, isReverse) {
      if (!isReverse) {
        switch (raceName) {
          case "第一場":
            return 1;
          case "第二場":
            return 2;
          case "第三場":
            return 3;
          case "第四場":
            return 4;
          case "第五場":
            return 5;
          case "第六場":
            return 6;
          case "第七場":
            return 7;
          case "第八場":
            return 8;
          case "第九場":
            return 9;
          case "第十場":
            return 10;
          case "第十一場":
            return 11;
          case "第十二場":
            return 12;
          case "第十三場":
            return 13;
          case "第十四場":
            return 14;
          case "第十五場":
            return 15;
        }
      } else {
        switch (raceName) {
          case 1:
            return "第一場";
          case 2:
            return "第二場";
          case 3:
            return "第三場";
          case 4:
            return "第四場";
          case 5:
            return "第五場";
          case 6:
            return "第六場";
          case 7:
            return "第七場";
          case 8:
            return "第八場";
          case 9:
            return "第九場";
          case 10:
            return "第十場";
          case 11:
            return "第十一場";
          case 12:
            return "第十二場";
          case 13:
            return "第十三場";
          case 14:
            return "第十四場";
          case 15:
            return "第十五場";
        }
      }
    }
    //TODO temporary get raceInfo
    //Syntax: /raceInfo/20190109/HV/1
    console.time("raceInfo");

    this.$vs.loading({ type: "sound" });
    try {
      await Promise.all(
        [
          (response = await this.$http.get("racing/oncc")),
          (corpArr = (await this.$http.get("racing/corp")).data),
          (totalRaceInfo = (await this.$http.get("racing/latestRaceInfo")).data)
        ]
        //   raceInfo = Array.from(Array(12).keys()).map(key => {
        //      var res = await this.$http.get( `raceInfo/20190109/HV/${key+1}`);
        //  })
        // raceInfo = Array.from(Array(12).keys()).map(key => await this.$http.get(`raceInfo/20190109/HV/${key+1}`));
      );
      this.$vs.loading.close();

      console.timeEnd("raceInfo");

      totalRaceInfo.AllRaceArray.forEach(function(x) {
        raceInfo[x.場次 - 1] = x;
      });
      totalRaceCount = totalRaceInfo.AllRaceArray.length;

      this.raceInfo = raceInfo;
      this.onccLists = response.data;
      var OnccTipsDate = response.data.date;
      this.totalRaceCount = totalRaceCount;
      this.OnccTipsDate = this.onccLists.date;
      this.onccLists.data.forEach(function(x) {
        //Flatten tips
        x.tips.forEach(function(y) {
          var tmpTips = {
            writer: x.writer,
            type: x.type,
            racenum: y.racenum,
            choices: y.choices
          };
          HandleTips(tmpTips);
        });
      });
      //formattedTipsArr[raceNum].horseSelectedCount.forEach(function(item, index) {
      formattedTipsArr.forEach(function(item, index) {
        if (item == null || item.horseSelectedCount == null) {
          return;
        }
        //Sort decending
        item.horseSelectedCount.sort((a, b) => (a.count > b.count ? -1 : 1));

        const maxObj = item.horseSelectedCount.reduce(function(prev, current) {
          return prev.count > current.count ? prev : current;
        });
        var maxCount = maxObj.count;
        var filteredArray = item.horseSelectedCount.filter(function(e1) {
          return e1.count == maxCount;
        });
        //If the array only contains 1 object, make it identical and push it to the suggestion array
        var isIdentical = filteredArray.length == 1;

        if (isIdentical) {
          formattedTipsArr[index].horseSuggestion = filteredArray[0];
        }
      });

      //Map Tips choice with rider:
      formattedTipsArr.forEach(function(e, index) {
        if (e == null || e.horseSelectedCount == null) {
          return;
        }
        e.raceNumCHT = getNumber(e.raceNumInt, true);

        if (totalRaceInfo.RaceDateStr == OnccTipsDate) {
          e.horseSelectedCount.forEach(function(horse) {
            var horseNameWithoutNumber = horse.name.replace(/[0-9]/g, "");
            //Get rider name from raceInfo
            var filteredArr = raceInfo[index - 1].參賽馬匹.filter(x =>
              x.馬名.includes(horseNameWithoutNumber)
            );
            if (filteredArr.length == 1) {
              var riderName = filteredArr[0].騎師;

              //filter out meaningless symbol
              riderName = riderName.replace(/[0-9()\+\-]/g, "");
              horse.riderName = riderName;
              var existingRecord = jockeyChallengeStat.find(
                x => x.riderName == riderName
              );
              if (existingRecord == null) {
                jockeyChallengeStat.push({
                  riderName: riderName,
                  count: horse.count
                });
              } else {
                existingRecord.count += horse.count;
              }
              //Add it to racingChallengeArray
            }
          });
        }
      });

      this.formattedTipsArr = formattedTipsArr;
      this.jockeyChallengeStat = jockeyChallengeStat.sort((a, b) =>
        a.count > b.count ? -1 : 1
      );
      this.formattedRaceInfo = [];

      //Build formatted raceInfo
      raceInfo.forEach(function(item, index) {
        if (formattedRaceInfo[index] == null) {
          formattedRaceInfo[index] = {};
          formattedRaceInfo[index].參賽馬匹 = [];
          formattedRaceInfo[index].地點 = raceInfo[index].地點;
          formattedRaceInfo[index].場次 = raceInfo[index].場次;
          formattedRaceInfo[index].日期 = raceInfo[index].日期;
          formattedRaceInfo[index].星期 = raceInfo[index].星期;
          formattedRaceInfo[index].時間 = raceInfo[index].時間;
          formattedRaceInfo[index].比賽 = raceInfo[index].比賽;

          formattedRaceInfo[index].獎金 = raceInfo[index].獎金;
          formattedRaceInfo[index].評分 = raceInfo[index].評分;
          formattedRaceInfo[index].班次 = raceInfo[index].班次;

          formattedRaceInfo[index].全部資訊 = raceInfo[index].全部資訊;
        }

        item.參賽馬匹.forEach(function(horse) {
          var formattedRiderName = horse.騎師.replace(/[0-9()\+\-]/g, "");
          if (!isNaN(horse["獨贏"]) && !isNaN(horse["位置"])) {
            horse["獨贏/位置"] = (horse["獨贏"] / horse["位置"]).toFixed(2);
          }
          if (corpArr[formattedRiderName] != null) {
            if (corpArr[formattedRiderName][horse.練馬師] != null) {
              var targetCorpArr = corpArr[formattedRiderName][horse.練馬師];

              //Calculate win rate / top 3 rate

              function parseArray(value) {
                value = parseInt(value);
                if (isNaN(value)) {
                  return 0;
                }
                return value;
              }
              var total = 0;
              targetCorpArr.forEach(function(x) {
                total += parseArray(x);
              });

              var winRate = parseArray(targetCorpArr[0]) / total;
              var top3Rate =
                (parseArray(targetCorpArr[0]) +
                  parseArray(targetCorpArr[1]) +
                  parseArray(targetCorpArr[2])) /
                total;
              winRate = (winRate * 100).toFixed(2);
              top3Rate = (top3Rate * 100).toFixed(2);
              var flatternArray = targetCorpArr.toString();

              horse["騎練(冠亞季負)"] = flatternArray;
              horse["騎練(冠亞季負)Arr"] = targetCorpArr;
              horse["騎練(冠%)"] = winRate;
              horse["騎練(冠亞季%)"] = top3Rate;
            } else {
              horse["騎練(冠亞季負)"] = "????";
              console.log(
                `Mapping ${formattedRiderName} : ${horse.練馬師} not found.`
              );
            }
          } else {
            horse["騎練(冠亞季負)"] = "????";
            console.log("騎師 " + formattedRiderName + " not found.");
          }
          horse["排位體重+負磅"] =
            parseInt(horse["排位體重"]) + parseInt(horse["負磅"]);
          formattedRaceInfo[index].參賽馬匹.push(horse);
        });
      });

      this.formattedRaceInfo = formattedRaceInfo;
      this.RaceLocation = formattedRaceInfo[0].地點;
      this.RaceDate = formattedRaceInfo[0].日期;
    } catch (error) {
      this.$vs.loading.close();
      this.dialog = true;
      this.DialogErrorMsg = "API爆炸";
      //alert(error);
    }
  }
};
</script>

<style scoped>
.loading-dialog {
  background-color: "#303030";
}
/* To display name without resize */
.racingSchedule td {
  white-space: nowrap;
}
</style>